import { uniqueId } from 'lodash-es';
import { GlIcon, GlTooltip, GlDisclosureDropdown, GlResizeObserverDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { titleInLinkSafeHtmlConfig } from '~/lib/dompurify';
import { PanelBreakpointInstance } from '~/panel_breakpoint_instance';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import DisclosureHierarchyItem from './disclosure_hierarchy_item.vue?vue3';
export default {
    name: 'DisclosureHierarchy',
    components: {
        GlDisclosureDropdown,
        GlIcon,
        GlTooltip,
        DisclosureHierarchyItem
    },
    directives: {
        GlResizeObserver: GlResizeObserverDirective,
        SafeHtml
    },
    mixins: [
        glSlotsMixin
    ],
    titleInLinkSafeHtmlConfig,
    props: {
        /**
     * A list of items in the form:
     * ```
     * {
     *   titleHtml: String (rendered as HTML)
     *   title:     String (plain text; label for the collapsed ellipsis dropdown, where HTML can't be used)
     *   message:   String (rendered as plain text)
     *   icon:      String, optional
     * }
     * ```
     * Either a message, or both titleHtml and its plain-text title, must be provided.
     */ items: {
            type: Array,
            required: false,
            default: ()=>[],
            validator: (items)=>{
                return items.every((item)=>item.titleHtml && item.title || item.message);
            }
        },
        /**
     * When set, displays only first and last item, and groups the rest under an ellipsis button
     */ withEllipsis: {
            type: Boolean,
            default: false,
            required: false
        },
        /**
     * When set, a tooltip displays when hovering middle ellipsis button
     */ ellipsisTooltipLabel: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            itemUuid: uniqueId('disclosure-hierarchy-'),
            isMobile: false
        };
    },
    computed: {
        middleItems () {
            if (this.isMobile) {
                return this.items.slice(0, -1).map((item)=>({
                        ...item,
                        text: item.title ?? item.message
                    }));
            }
            return this.items.slice(1, -1).map((item)=>({
                    ...item,
                    text: item.title ?? item.message
                }));
        },
        firstItem () {
            return this.items[0];
        },
        lastItemIndex () {
            return this.items.length - 1;
        },
        lastItem () {
            return this.items[this.lastItemIndex];
        }
    },
    methods: {
        itemId (index) {
            return `${this.itemUuid}-item-${index}`;
        },
        handleResize () {
            this.isMobile = [
                'sm',
                'xs'
            ].includes(PanelBreakpointInstance.getBreakpointSize());
        }
    }
};
